export const useURLQuery = () => {
  const params = new URLSearchParams(window.location.search)

  const getUrl = (url: string, query = params) =>
    params.size > 0 ? url + '?' + query.toString() : url

  return {
    params,
    getUrl,
  }
}
